module.exports = __webpack_public_path__ + "img/Cooling---AC-with-Flower.6e598878.jpg";